import cookie from 'cookie'

const chaveToken = 'TAG_TOKEN'
const chaveNomeAssociado = 'TAG_ASSOCIADO_NOME'
const tokenCookieMaxAge = 365 * 24 * 60 * 60

const buildTokenCookieAttributes = () => {
  const { hostname } = window.location
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1'
  const domain = isLocalhost ? '' : 'domain=taglivros.com;'
  const secure = isLocalhost ? '' : 'Secure;'
  return `${domain}path=/;${secure}SameSite=Strict`
}

export const getToken = () => {
  const tokenFromLocalStorage = localStorage.getItem( chaveToken )
  const tokenFromCookie = cookie.parse( document.cookie )[ chaveToken ]
  return tokenFromLocalStorage ? tokenFromLocalStorage : tokenFromCookie
}

export const setToken = token => {
  localStorage.setItem( chaveToken, token )
  document.cookie = `${chaveToken}=${token};${buildTokenCookieAttributes()};Max-Age=${tokenCookieMaxAge}`
}

export const deleteToken = () => {
  localStorage.removeItem( chaveToken )
  document.cookie = `${chaveToken}=;${buildTokenCookieAttributes()};Expires=Thu, 01 Jan 1970 00:00:01 GMT`
}

export const getNomeAssociado = () => localStorage.getItem( chaveNomeAssociado )

export const setNomeAssociado = nome => localStorage.setItem( chaveNomeAssociado, nome )

export const deleteNomeAssociado = () => localStorage.removeItem( chaveNomeAssociado )

export const deleteInfoAssociado = () => {
  deleteNomeAssociado()
  deleteToken()
}
